"use client"

import {
  Table,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TextBody,
  Tooltip,
} from "@opensea/ui-kit"
import { useTranslations } from "next-intl"

type Trait = {
  traitType: string
  value: string
}

type Props = {
  traits: Trait[]
}

export function MultiTraitTooltip({ traits }: Props) {
  const t = useTranslations("MultiTraitTooltip")

  if (!traits || traits.length === 0) {
    return null
  }

  return (
    <Tooltip
      content={
        <Table
          header={
            <TableHeader className="mb-1 bg-bg-primary">
              <TableRow>
                <TableHeaderCell>{t("attribute")}</TableHeaderCell>
                <TableHeaderCell>{t("trait")}</TableHeaderCell>
              </TableRow>
            </TableHeader>
          }
          itemKey={(trait, index) =>
            `${trait?.traitType}-${trait?.value}-${index}`
          }
          items={traits}
          renderRow={({ item: trait }) =>
            trait ? (
              <TableRow>
                <TableCell>
                  <TextBody size="sm">{trait.traitType}</TextBody>
                </TableCell>
                <TableCell>
                  <TextBody size="sm">{trait.value}</TextBody>
                </TableCell>
              </TableRow>
            ) : null
          }
          size="xs"
        />
      }
    >
      <TextBody>{t("multipleTraits", { count: traits.length })}</TextBody>
    </Tooltip>
  )
}
